import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Device } from '../../interfaces/api/device';
import { fetchDevices } from '../services/devices.service';
import { DeviceFilterParams } from '../../api/devices';

interface DeviceState {
	devices: {
		[id: number]: Device;
	};
	selectedDevice: Device | undefined;
	isLoading: boolean;
}

const initialState = {
	devices: [],
	selectedDevice: undefined,
	isLoading: false,
} as DeviceState;

export const fetchDevicesThunk = createAsyncThunk<Device[], { params: DeviceFilterParams }>(
	'device/fetchDevices',
	async ({ params }, { rejectWithValue }) => {
		try {
			return await fetchDevices(params);
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

const deviceSlice = createSlice({
	name: 'device',
	initialState,
	reducers: {
		selectDevice: (state, action: PayloadAction<number>) => {
			state.selectedDevice = state.devices[action.payload];
			localStorage.setItem('selectedDevice', String(state.devices[action.payload].id));
		},
		unSelectDevice: (state) => {
			state.selectedDevice = undefined;
			localStorage.removeItem('selectedDevice');
		},
		resetDevice: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchDevicesThunk.fulfilled, (state, action) => {
			const ret: { [id: number]: Device } = {};
			state.devices = action.payload.reduce((obj, device) => {
				obj[device.id] = device;
				return obj;
			}, ret);
			const selectedStorageDevice: string | null = localStorage.getItem('selectedDevice');
			if (selectedStorageDevice && state.devices[Number(selectedStorageDevice)]) {
				state.selectedDevice = state.devices[Number(selectedStorageDevice)];
			} else {
				if (action.payload.length > 0) {
					localStorage.setItem('selectedDevice', String(action.payload[0].id));
					state.selectedDevice = action.payload[0];
				}
			}
			state.isLoading = false;
		});
		builder.addCase(fetchDevicesThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchDevicesThunk.rejected, (state, action) => {
			state.devices = [];
			state.isLoading = false;
		});
	},
});

export const { selectDevice, unSelectDevice, resetDevice } = deviceSlice.actions;

export default deviceSlice;
